import { gateway } from "src/gateway";

export interface UpdateServiceAliasParams {
  jobId: number;
  serviceNameOverride: string | null;
}

export const updateServiceAlias = async ({ jobId, serviceNameOverride }: UpdateServiceAliasParams) => {
  const token = sessionStorage.getItem("token");

  const response = await gateway.patch(
    `/jobs/self/${jobId}/service-alias`,
    {
      serviceNameOverride,
    },
    {
      headers: {
        Authorization: `${token}`,
      },
    },
  );

  return response.data?.data ?? response.data;
};
